import {
  AddImiDeclarationPage,
  IMIDeclarationsPage,
  IMIListPage,
  ReportsListPage,
} from './pages'
import { AppRoute } from '@/modules/settings/types'
import { REPORT_ROUTES } from './routes-typed'

export const reportsRoutesMap: Record<string, string> = {
  reportsList: REPORT_ROUTES.reportsList.path,
  imiList: REPORT_ROUTES.imiList.path,
  imiDeclarations: REPORT_ROUTES.imiDeclarations.path,
  imiAdd: REPORT_ROUTES.imiAdd.path,
}

export const reportsRoutes: AppRoute[] = [
  {
    path: reportsRoutesMap.reportsList,
    component: ReportsListPage,
    exact: true,
    heightScreen: true,

    imiSidePanel: true,
  },
  {
    path: reportsRoutesMap.imiList,
    component: IMIListPage,
    exact: true,
     heightScreen: true,
    imiSidePanel: true,

  },
  {
    path: reportsRoutesMap.imiDeclarations,
    component: IMIDeclarationsPage,
    exact: true,
    heightScreen: true,
    imiSidePanel: true,
  },
  {
    path: reportsRoutesMap.imiAdd,
    component: AddImiDeclarationPage,
    exact: true,
    heightScreen: true,
    imiSidePanel: true,
  },
]
